export default "__VITE_ASSET__fc997bac__"